import { CHECK_KEY_LIST, REGEX } from "@config/constants";

const slicePath = (pathname) => `/${pathname.split("/")[1]}`;

export const checkExistPage = (list, pathname) => {
  const slicePathName = slicePath(pathname);
  if (list.indexOf(slicePathName) > -1) {
    return true;
  }
  return false;
};

export const checkExistPageWithPath = (list, pathname) => {
  if (list.some((url) => pathname.includes(url))) {
    return true;
  }
  return false;
};

export const checkNumberInput = (event, regex) => {
  if (!regex.test(event.key) && !CHECK_KEY_LIST.includes(event.key)) {
    event.preventDefault();
  }
};

export const checkDateFormat = (dateString) => {
  return REGEX.DATE_FORMAT.test(dateString);
};
